import {createApp} from "vue";
import App from "./App.vue";
import {BootstrapVue3} from "bootstrap-vue-3";
import router from "./router";
import i18n from "./locales";
import store from "./store";
import {createPinia} from 'pinia'


import {formatDate, formatTime} from "./hooks/useDateTimeFormat";
import {formatNumber} from "./hooks/useNumberFormat";

import "bootstrap/dist/js/bootstrap.bundle.min.js";
import './assets/tailwind.css'

const app = createApp(App);

const pinia = createPinia()
app.use(pinia)
app.provide("store", store);
app.use(BootstrapVue3);
app.use(router);
app.use(i18n);

app.config.globalProperties.$filters = {
    formatDate,
    formatTime,
    formatNumber
};

app.mount("#app");
